export default "__VITE_ASSET__BrBtswac__"